import React from 'react';
import './signForm.style.sass';
import {Button, ButtonToolbar, ControlLabel, Form, FormControl, FormGroup} from "rsuite";

const SignFormComponent = () => {
    return (
        <Form className='form-sign-component'>
            <FormGroup>
                <ControlLabel htmlFor='number'>شماره همراه</ControlLabel>
                <FormControl name="number"/>
            </FormGroup>
            <FormGroup>
                <ControlLabel htmlFor='code'>کد فعال سازی</ControlLabel>
                <FormControl name="code"/>
            </FormGroup>
            <FormGroup>
                <ControlLabel htmlFor='code'>کد فعال سازی</ControlLabel>
                <FormControl name="code"/>
            </FormGroup>
            <FormGroup>
                <ControlLabel htmlFor='code'>کد فعال سازی</ControlLabel>
                <FormControl name="code"/>
            </FormGroup>
            <FormGroup>
                <ControlLabel htmlFor='code'>کد فعال سازی</ControlLabel>
                <FormControl name="code"/>
            </FormGroup>
            <FormGroup>
                <ControlLabel htmlFor='code'>کد فعال سازی</ControlLabel>
                <FormControl name="code"/>
            </FormGroup>
            <FormGroup>
                <ButtonToolbar>
                    <Button className='btn-loggin' appearance="default">وارد شدن</Button>
                </ButtonToolbar>
            </FormGroup>
        </Form>
    );
};

export default SignFormComponent;